import { z } from 'zod';

export const DeliveryDestinationOptionsType = z.enum([
  'FC A/N自社倉庫',
  'FC A/N契約倉庫',
  'FC A/N他社倉庫',
  '他社A/N他社倉庫',
]);

export type DeliveryDestinationOptionsType = z.infer<typeof DeliveryDestinationOptionsType>;
